import React from 'react';
import {
  Box,
  Typography,
  BoxProps,
  TypographyProps,
  Stack,
} from '@mui/material';
import { t } from 'i18next';
import BackButton from '../common/BackButton';
import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';

interface ListTitleBoxProps extends Omit<BoxProps, 'title'> {
  title?: React.ReactNode;
  titleProps?: TypographyProps;
  onPrimaryClick?: () => void;
  primaryButtonText?: string;
  primaryButtonProps?: LoadingButtonProps;
  paddingTop?: string | number;
  paddingBottom?: string | number;
  primaryButtonDisabled?: boolean;
  onBackClick?: () => void;
}
// NOTE: The interface is correct. If any usage or prop expects 'string', update it to accept ReactNode.

const ListTitleBox: React.FC<ListTitleBoxProps> = ({
  title,
  titleProps,
  onPrimaryClick,
  primaryButtonText = t('common.create'),
  primaryButtonProps,
  primaryButtonDisabled = false,
  paddingTop = '16px',
  paddingBottom = '8px',
  onBackClick,
  ...boxProps
}) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      width="100%"
      {...boxProps}
    >
      <Stack direction="row" alignItems="center" spacing={0.5}>
        {onBackClick && <BackButton onClick={onBackClick} />}
        {title &&
          (typeof title === 'string' ? (
            <Typography variant="h4" {...titleProps}>
              {title}
            </Typography>
          ) : (
            title
          ))}
      </Stack>
      {onPrimaryClick && (
        <LoadingButton
          onClick={onPrimaryClick}
          size="large"
          variant="contained"
          disabled={primaryButtonDisabled}
          {...primaryButtonProps}
        >
          {primaryButtonText}
        </LoadingButton>
      )}
    </Box>
  );
};

export default ListTitleBox;
